import React,{memo, useCallback, useMemo, useRef, useEffect, useState} from 'react';
import {Divider, Grid, Drawer, Button, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled, useTheme } from "@mui/material/styles";
import { useServer } from '../../../../context/ServerContext';

import Logo from '../../../../assets/img/APP-scapp.png'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DrawerFooter from './utils/DrawerFooter';
import DrawerList from './utils/DrawerList';
import {LogoutUsuario} from '../../../../utils/ApiLogin'


const drawerWidth = '15vw';
const drawerHeight = '90vh';


const DrawerHeader = styled("div")(({ theme })  => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
}));



  

function TemporaryDrawer({
    open,
    setOpen,
    setNameCentro,
    translate,
    capitalize,
    SWVersion,
    setViewMode,
    handleLogoMouseEnter, handleLogoMouseLeave,
    regionSeleccionada, setRegionSeleccionada,
    areaSeleccionada,   setAreaSeleccionada,
    centroSeleccionado,setCentroSeleccionado,
    selectedCenters,    setSelectedCenters,
    permisosCentros,
    nivelSeleccionado,  setNivelSeleccionado
}) {

    const [showAreas, setShowAreas] = useState(true);
    const [showOptions, setShowOptions] = useState(true);
    const [posicionArea, setPosicionArea] = useState(null)
    const [initialized, setInitialized] = useState(false);

    // const [centroSeleccionado, setcentroSeleccionado] = useState(null);
    const drawerRef = useRef(null);
    const navigate = useNavigate();
    const { servidor } = useServer();
    const styleFont='1vw'
    const styleFontText='0.75vw'
    const stylep175='0.6vw'
    const heightCelda ='5.6vh'
    const toggleOptions = useCallback(() => {
        setShowOptions((prev) => !prev);
    }, []);

    //* ------------------------ Función: handleHome ------------------------------------------------------
    //? Descripción: Redirige a la página de inicio al hacer clic en el menú de usuario.
    const handleHome = useCallback(() => {
        window.location.href = "/home";
    }, []);

            //* ------------------------ Función: handleExit ------------------------------------------------
    //? Descripción: Maneja el cierre del menú de usuario y realiza redirección.
    const handleExit = useCallback(async () => {
        await LogoutUsuario(servidor);
        window.location.href = "/"; // Cambia "/Añadir" por la ruta que deseas redirigir
    }, [servidor]);


    // *  -----------------------------  Función: handleRegionClick ------------------------------------------------
        //? Descripción: 
        //? Función utilizada para poder seleccionar Regiones
        //? Parámetros:
        // - region : objeto con atributo 'clientId' que corresponde al indice del cliente 'name' que corresponde a la region seleccionada
        //            y un atributo 'area' que es un array de objetos de las areas de la region seleccionada, objeto que corresponde al que se desbribe en los parametros de handleAreaClick 
        const handleRegionClick = useCallback((region) => {
            const regionName = typeof region === 'string' ? region : region?.name;
            if (!regionName) return;
            setRegionSeleccionada(regionName);
            setAreaSeleccionada('');
            setCentroSeleccionado('');
            setSelectedCenters([]);
            localStorage.setItem('REGION', JSON.stringify(regionName));
            localStorage.removeItem('AREA');
            localStorage.removeItem('CENTRO');
        }, [setAreaSeleccionada, setCentroSeleccionado, setRegionSeleccionada, setSelectedCenters]);
    
        // *  -----------------------------  Función: handleAreaClick ------------------------------------------------
        //? Descripción: 
        //? Función utilizada para poder seleccionar areas
        //? Parámetros:
        // - area : objeto con atributo 'name' que corresponde al area seleccionada y un atributo 'centers' que es un array de los centros de esa area
        const handleAreaClick = useCallback((area) => {
          const areaName = typeof area === 'string' ? area : area?.name;
          if (!areaName) return;
            setAreaSeleccionada(areaName);
            setCentroSeleccionado('');
            setSelectedCenters([]);
            localStorage.setItem('AREA', JSON.stringify(areaName));
            localStorage.removeItem('CENTRO');

            // setCentro(area.centers)
            // console.log('area center seleccionada',area.centers)
            // console.log('areas seleccionada',area)
        }, [setAreaSeleccionada, setCentroSeleccionado, setSelectedCenters]);

         // *  -----------------------------  Función: handleCentroClick ------------------------------------------------
        //? Descripción: 
        //? Función utilizada para poder seleccionar centro
        //? Parámetros:
        // - centro : string nombre del centro 
        const handleCentroClick = useCallback((centro) => {
          const centroName = typeof centro === 'string' ? centro : centro?.name;
          if (!centroName) return;
            setSelectedCenters([centroName]);
            setCentroSeleccionado(centroName)
            localStorage.setItem('CENTRO', JSON.stringify(centroName));
        }, [setCentroSeleccionado, setSelectedCenters]);

        
        //  * --------------------------------------- useEffect: para cerrar el drawer al presionar fuera del cajon
        useEffect(() => {
        // Función para cerrar el Drawer cuando se hace clic fuera de él
        const handleOutsideClick = (event) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
            setOpen(false);
            }
        };
    
        // Agregar el event listener cuando el Drawer está abierto
        if (open) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            // Remover el event listener cuando el Drawer está cerrado
            document.removeEventListener('mousedown', handleOutsideClick);
        }
    
        // Limpiar el event listener cuando el componente se desmonta
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
        }, [open]);
    

        const DrawerListProps = useMemo(() => ({
            showOptions , 
            handleHome ,
            styleFont ,
            translate ,
            handleExit ,
            regionSeleccionada ,
            capitalize ,
            showAreas ,
            handleAreaClick ,
            areaSeleccionada ,
            centroSeleccionado,
            posicionArea ,
            setPosicionArea ,
            selectedCenters ,
            handleCentroClick ,
            handleRegionClick ,
            setNameCentro ,
            navigate ,
            setShowAreas ,
            open ,
            permisosCentros,
            nivelSeleccionado,
            setNivelSeleccionado,
}) , [
    showOptions,
    handleHome,
    styleFont,
    translate,
    handleExit,
    regionSeleccionada,
    capitalize,
    showAreas,
    handleAreaClick,
    areaSeleccionada,
    centroSeleccionado,
    posicionArea,
    setPosicionArea,
    selectedCenters,
    handleCentroClick,
    handleRegionClick,
    setNameCentro,
    navigate,
    setShowAreas,
    open,
    permisosCentros,
    nivelSeleccionado,
    setNivelSeleccionado,
]) 

        const DrawerFooterProps = useMemo(() => ({
            stylep175 : stylep175,
            translate : translate,
            SWVersion : SWVersion,

        }), [SWVersion, stylep175, translate])

  return (
    <Grid container justifyContent="center" item xs={1} sx={{ display: "flex" }} style={{ cursor: 'default !important', userSelect: 'none', }} 
        ref={drawerRef} 
        onMouseEnter={() => handleLogoMouseEnter()}
        // onMouseLeave={() => handleLogoMouseLeave()}
    >
      <Drawer open={open}   variant="persistent" anchor="left"
        sx={{
        width: drawerWidth,
        // height:drawerHeight,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: drawerWidth,
            height:'100vh',//drawerHeight,
            // marginTop:'6.7vh',
            // marginLeft:'1vw',
            // borderRadius:'2vh',
            borderRight: ' solid 0.1vw #DE4E11',
            backgroundColor:'#13131f',
            // background:'linear-gradient(#393939, #1a1a1a)',
            display: 'flex',
        },
        // border:'solid 0.1vh'
        borderRadius:'2vh',
        }}>
        <DrawerHeader 
            // onClick={toggleOptions}
          style={{ display: 'flex', justifyContent: 'space-between', minHeight:heightCelda, maxHeight:heightCelda,
            backgroundColor:'#13131f', '&:hover': {
          // backgroundColor: '#3f3f3f', 
          // puedes cambiar el color y grosor del borde a tu gusto
          }, }}
        >
            {/* <Button onClick={toggleOptions} fullWidth color='inherit'> */}
                <Grid container justifyContent={'center'}>
                    <Grid container justifyContent={'flex-start'} alignContent={'center'} item xs={12}>
                        <img
                            src={Logo}
                            style={{ paddingLeft: '0.5vw', width: '3vw', aspectRatio:'1', paddingTop: '1vh', marginTop:'-1vh' }}
                            alt={''}
                        />
                    </Grid>
                </Grid>
            {/* </Button> */}
        </DrawerHeader>
        <Divider />
        <DrawerList  {...DrawerListProps}/>
        <DrawerFooter {...DrawerFooterProps}/>
      </Drawer>
    </Grid>
  );
}

export default memo(TemporaryDrawer);
